"use strict";

/**
 * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
 * templates and such with AngularJS. Use this simple directive to
 * tame this beast once and for all.
 *
 * Usage:
 * <input type="text" autofocus>
 *
 * License: MIT
 */

angular.module("autofocus", []);

require("./autofocus.directive.js");



//////////////////
// WEBPACK FOOTER
// ./core/autofocus/autofocus.module.js
// module id = 336
// module chunks = 0